import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { BroadcastChannel } from 'broadcast-channel';
import MenuPopover from '../../components/MenuPopover';
import { logoutSuccess, guideHandler, ComingFrom, FromGeneralAssessmentView, setB2BPage, languagecodevalue } from '../../store/reducer';
import loginServices from '../../services/loginServices';
import { resolveLandingRoute } from '../../utils/roleLanding';


// eslint-disable-next-line react/prop-types
export default function AccountPopover({ coming, CallBack,navigationItems = [],selectedItem = '',onNavigationClick = () => {}}) {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { t } = useTranslation('translation');
  const { pathname } = useLocation();
  const userInfo = useSelector((state) => state.userInfo);
  const defaultlanguage = useSelector((state) => state.languagecode);
  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
  const [open, setOpen] = useState(null);
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.isLogin);
  const [show, setShow] = useState(false);
  const logoutChannel = new BroadcastChannel('logout');

  const handleOpen = (event) => {

    if (coming === 'B2B') {
      CallBack("opened")
    }
    if (coming === 'B2C') {
      CallBack("opened1")
    }
    setOpen(event.currentTarget);
  };


  const handleClose = () => {
    setOpen(null);
    // CallBack("opened")
  };


  const handleLogout = () => {
    logoutChannel.postMessage('Logout');
    sessionStorage.removeItem('coursesSearch',"")
    dispatch(logoutSuccess());
    dispatch(FromGeneralAssessmentView(false));
    dispatch(setB2BPage('paid'));
    dispatch(ComingFrom("Dashboard"))
    dispatch(languagecodevalue(defaultlanguage));

    localStorage.setItem('selectedToggle', 'paid');
    // localStorage.removeItem("ua")
    // localStorage.removeItem("ip")
    localStorage.removeItem("locationPermission")
    navigate('/login');

    loginServices.logout();
  };

  const guidHandler = () => {
    dispatch(guideHandler(true));
    handleClose();
  };

  const handleGotoDashboard = () => {
    if (isLogin) {
      // Shared resolver - see utils/roleLanding. The old branch ended in an
      // `else` that sent unrecognised roles to /auth/subscribe, a route their
      // tree does not contain.
      const target = resolveLandingRoute(userInfo);
      if (target) {
        if (target === '/app/course') dispatch(languagecodevalue('en'));
        if (target.startsWith('/auth/')) {
          localStorage.setItem('from', 'Courses');
          dispatch(ComingFrom('Dashboard'));
        }
        navigate(target);
      }
    }
    setOpen(null);

  };

  // New handler for mobile navigation items
  const handleMobileNavClick = (item) => {
    if (onNavigationClick) {
      onNavigationClick(item);
    }
    handleClose();
  };

  function stringAvatar() {
    const fullName = userInfo;

    return {
      sx: {
        // bgcolor: stringToColor(name),
        fontSize: '1.4rem',
        fontWeight: '600',
      },
      children: fullName?.lastName !== null && fullName?.lastName !== ""
        ? `${fullName?.firstName.charAt(0).toUpperCase()}${fullName?.lastName.charAt(0).toUpperCase()}`
        : `${fullName?.firstName.charAt(0).toUpperCase()}`

      // children: `${fullName?.firstName.charAt(0).toUpperCase()}${fullName?.lastName.charAt(0).toUpperCase()}`,
    };
  }

  useEffect(() => {
    if (pathname.includes('/app/course-details') || pathname.includes('/auth/course-details')) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [pathname]);
  
  const translatedMenuOptions = [
    {
      label: userRole === 'SUPER_ADMIN' || userRole === 'CLIENT_ADMIN' || userRole === 'MANAGER' ? 'Profile' : t('Profile'),
      icon: 'eva:person-fill',
      linkTo: '/app/account',
    },
  ];

  return (
    <>
      <IconButton 
        className='userProfile w-8 h-8 sm:w-10 sm:h-10'
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          marginLeft: 5,
          p: 0,
          '@media (max-width: 900px)': {
            marginLeft: '20px',
          },
          '@media (max-width: 1100px)': {
            marginLeft: '50px',
          },
        }}>
        <Box sx={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end' }}>
          <Avatar 
            sx={{ ml: 20 }} 
            {...stringAvatar()} 
            className="w-8 h-8 sm:w-10 sm:h-10"
          />
        </Box>
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        {/* User Info Section */}
        <Box sx={{ my: 1.5, paddingLeft: '8px !important' }} pl={2}>
          <Typography variant="subtitle2" noWrap>
            {userInfo && userInfo.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userInfo && userInfo.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* Mobile Navigation Section - Only visible on mobile (below md breakpoint) */}
        {navigationItems.length > 0 && (
          <Box className="block md:hidden">
            {navigationItems.map((item) => (
              <MenuItem
                key={item}
                onClick={() => handleMobileNavClick(item)}
                component={RouterLink}
                to="/auth/subscribe"
                sx={{
                  mx: 1,
                  mb: 0.5,
                  px: 2,
                  py: 1,
                  backgroundColor: selectedItem === item ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                  fontWeight: selectedItem === item ? 700 : 500,
                  color: selectedItem === item ? 'primary.main' : 'text.primary',
                  borderLeft: selectedItem === item ? '3px solid' : '3px solid transparent',
                  borderColor: selectedItem === item ? 'primary.main' : 'transparent',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: selectedItem === item 
                      ? 'rgba(25, 118, 210, 0.12)' 
                      : 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
              >
                {item === 'Assessments' ? "Test Series":item}
              </MenuItem>
            ))}
            
            <Divider sx={{ borderStyle: 'dashed', my: 1, mt: 1.5 }} />
          </Box>
        )}

        {/* Desktop Dashboard Link - Hidden on mobile when navigationItems exist */}
        <MenuItem 
          onClick={handleGotoDashboard} 
          sx={{ 
            ml: 1, 
            mt: 1, 
            mr: 1,
            display: navigationItems.length > 0 ? { xs: 'none', md: 'flex' } : 'flex'
          }}
        >
          {userRole === 'SUPER_ADMIN' || userRole === 'CLIENT_ADMIN' || userRole === 'MANAGER' ? 'Dashboard' : t('Dashboard')}
        </MenuItem>

        {/* Profile and other menu options */}
        <Stack sx={{ p: 1 }}>
          {translatedMenuOptions.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => {
                navigate(userRole === 'USER_DTC' ? '/auth/account' : '/app/account', { state: { from: pathname } });
                handleClose();
              }}
            >
              {option.label}
            </MenuItem>
          ))}

          {userRole === 'USER_DTC' && process.env.REACT_APP_ENV !== 'prod' && (
            <MenuItem to={'/auth/subscriptions'} component={RouterLink} onClick={handleClose} sx={{ mt: 1 }}>
              {userRole === 'SUPER_ADMIN' || userRole === 'CLIENT_ADMIN' ? 'Subscriptions' : t('Subscriptions')}
            </MenuItem>
          )}
        </Stack>

        {/* Take Tour option */}
        {show && (
          <>
            <Divider sx={{ borderStyle: 'dashed' }} />

            <MenuItem onClick={guidHandler} sx={{ m: 1 }}>
              {userRole === 'SUPER_ADMIN' || userRole === 'CLIENT_ADMIN' || userRole === 'MANAGER' ? 'Take Tour' : t('Take Tour')}
            </MenuItem>
          </>
        )}
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {userRole === 'SUPER_ADMIN' || userRole === 'CLIENT_ADMIN' || userRole === 'MANAGER' ? 'Logout' : t('Logout')}
        </MenuItem>
      </MenuPopover>
    </>
  );
}